"use strict";
/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0.
 */

var _regeneratorRuntime = require("/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceClientMqtt5Adapter = exports.ServiceClientMqtt311Adapter = void 0;

var aws_crt_1 = require("aws-crt");
/**
 * Simple adapter for low-level MQTT service clients to use the MQTT311 client.  Since the interface is just the
 * MQTT311 client's interface, all we need to do is forward.
 *
 * @internal
 */


var ServiceClientMqtt311Adapter = /*#__PURE__*/function () {
  function ServiceClientMqtt311Adapter(connection) {
    _classCallCheck(this, ServiceClientMqtt311Adapter);

    this.connection = connection;
  }

  _createClass(ServiceClientMqtt311Adapter, [{
    key: "publish",
    value: function publish(topic, payload, qos) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.connection.publish(topic, payload, qos));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(topic, qos, on_message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.connection.subscribe(topic, qos, on_message));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return ServiceClientMqtt311Adapter;
}();

exports.ServiceClientMqtt311Adapter = ServiceClientMqtt311Adapter;
/**
 * Adapter for low-level MQTT service clients to use the MQTT5 client.
 *
 * In addition to converting between the API contracts, adaptation requires constrained simulation of certain
 * features of the MQTT311 client (per subscription callbacks).  Full emulation of the topic tried is not needed
 * because all subscriptions are done with individual, non-wildcarded topics.
 *
 * @internal
 */

var ServiceClientMqtt5Adapter = /*#__PURE__*/function () {
  function ServiceClientMqtt5Adapter(client) {
    _classCallCheck(this, ServiceClientMqtt5Adapter);

    this.client = client;
    this.subscriptionHandlers = new Map();
    client.on('messageReceived', this.onMessageReceivedHandler.bind(this));
  }

  _createClass(ServiceClientMqtt5Adapter, [{
    key: "onMessageReceivedHandler",
    value: function onMessageReceivedHandler(eventData) {
      var _a;

      var publish = eventData.message;
      var topic = publish.topicName;
      var handler = this.subscriptionHandlers.get(topic);

      if (handler) {
        /* The payload field of a PublishPacket is always an ArrayBuffer */
        handler(topic, publish.payload, false, publish.qos, (_a = publish.retain) !== null && _a !== void 0 ? _a : false);
      }
    }
  }, {
    key: "publish",
    value: function publish(topic, payload, qos) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var result, puback;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return this.client.publish({
                              topicName: topic,
                              payload: payload,
                              qos: qos
                            });

                          case 3:
                            result = _context3.sent;

                            if (!(result === undefined)) {
                              _context3.next = 7;
                              break;
                            }

                            if (qos == aws_crt_1.mqtt.QoS.AtMostOnce) {
                              resolve({});
                            } else {
                              reject("Publish failed due to internal error");
                            }

                            return _context3.abrupt("return");

                          case 7:
                            puback = result;

                            if (aws_crt_1.mqtt5.isSuccessfulPubackReasonCode(puback.reasonCode)) {
                              resolve({});
                            } else {
                              reject(new aws_crt_1.CrtError("Publish failed with reason code: " + puback.reasonCode));
                            }

                            _context3.next = 14;
                            break;

                          case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3["catch"](0);
                            reject(_context3.t0);

                          case 14:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this, [[0, 11]]);
                  }));
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(topic, qos, on_message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var result, reasonCode;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            this.subscriptionHandlers.set(topic, on_message);
                            _context5.next = 4;
                            return this.client.subscribe({
                              subscriptions: [{
                                topicFilter: topic,
                                qos: qos
                              }]
                            });

                          case 4:
                            result = _context5.sent;
                            reasonCode = result.reasonCodes[0];

                            if (!aws_crt_1.mqtt5.isSuccessfulSubackReasonCode(reasonCode)) {
                              _context5.next = 10;
                              break;
                            }

                            resolve({
                              topic: topic,
                              qos: reasonCode
                            });
                            _context5.next = 11;
                            break;

                          case 10:
                            throw new aws_crt_1.CrtError("Subscribe failed with reason code: " + reasonCode);

                          case 11:
                            _context5.next = 17;
                            break;

                          case 13:
                            _context5.prev = 13;
                            _context5.t0 = _context5["catch"](0);
                            this.subscriptionHandlers.delete(topic);
                            reject(_context5.t0);

                          case 17:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this, [[0, 13]]);
                  }));
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }]);

  return ServiceClientMqtt5Adapter;
}();

exports.ServiceClientMqtt5Adapter = ServiceClientMqtt5Adapter;